"use strict";
/* globals module */
/**
 * @module commerceCustomerRoute
 * @description Baasic Commerce Customer Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Customer Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CommerceCustomerRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCustomerRoute, _super);
    function CommerceCustomerRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/customers/{systemName}/{?customerId,searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/customers/{systemName}/{id}/{?embed,fields}';
        _this.updateRoute = 'commerce/customers/{systemName}/{id}';
        _this.deleteRoute = 'commerce/customers/{systemName}/{id}';
        return _this;
    }
    /**
     * Parses find commerce customers route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceCustomerRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceCustomerRoute.prototype.find = function (options) {
        return this.baseFind(this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.get(id, options);
     **/
    CommerceCustomerRoute.prototype.get = function (id, options) {
        return this.baseGet(this.getRoute, id, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.update(data);
     **/
    CommerceCustomerRoute.prototype.update = function (data) {
        return this.baseUpdate(this.updateRoute, data);
    };
    /**
     * Parses delete route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.delete(data);
     **/
    CommerceCustomerRoute.prototype.delete = function (data) {
        return this.baseDelete(this.deleteRoute, data);
    };
    var _a;
    CommerceCustomerRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCustomerRoute);
    return CommerceCustomerRoute;
}(common_1.BaseRoute));
exports.CommerceCustomerRoute = CommerceCustomerRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
